import { ACTIONS, SUPPORTED_LANGUAGES } from '../Constants';
import { VerbFetch } from '../VerbFetch';

export const _privateChangeLanguage = (url = '', languageCode) => (dispatch) => {
    if (!(languageCode in SUPPORTED_LANGUAGES)) {
        // log some error message
        return null;
    }

    const jsonFile = SUPPORTED_LANGUAGES[languageCode].languageFile;

    // retrieve messages
    return VerbFetch(`${url}/build/languages/${jsonFile}`).then((payload) => {
        let messageObject = payload;
        if (typeof payload === 'string') {
            messageObject = JSON.parse(payload);
        }

        dispatch({
            type: ACTIONS.CHANGE_LANGUAGE,
            payload: {
                languageCode,
                messages: messageObject,
                languageLoaded: true
            }
        });
    });
};

export const changeLanguage = (pathsWebContext, languageCode) =>
    _privateChangeLanguage(pathsWebContext.clientUrl, languageCode);

export const adminChangeLanguage = (pathsWebContext, languageCode) =>
    _privateChangeLanguage(pathsWebContext.adminUrl, languageCode);
